var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanTooltipIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#6CDDD7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01869 7.748V6.476C6.45069 6.45467 6.78136 6.364 7.01069 6.204C7.24536 6.03867 7.36269 5.796 7.36269 5.476V5.364C7.36269 5.11867 7.28802 4.92933 7.13869 4.796C6.98936 4.65733 6.78936 4.588 6.53869 4.588C6.27202 4.588 6.05869 4.66533 5.89869 4.82C5.73869 4.97467 5.62936 5.172 5.57069 5.412L4.81069 5.108C4.85869 4.94267 4.92802 4.78267 5.01869 4.628C5.11469 4.47333 5.23469 4.33733 5.37869 4.22C5.52269 4.09733 5.69336 4.00133 5.89069 3.932C6.08802 3.85733 6.31469 3.82 6.57069 3.82C6.83202 3.82 7.06936 3.85733 7.28269 3.932C7.49602 4.00667 7.67736 4.11333 7.82669 4.252C7.97602 4.38533 8.09069 4.55067 8.17069 4.748C8.25069 4.94 8.29069 5.15333 8.29069 5.388C8.29069 5.628 8.24802 5.844 8.16269 6.036C8.08269 6.22267 7.97336 6.38267 7.83469 6.516C7.70136 6.64933 7.54936 6.75867 7.37869 6.844C7.20802 6.924 7.03202 6.98 6.85069 7.012V7.748H6.01869ZM6.44269 9.596C6.24002 9.596 6.09069 9.548 5.99469 9.452C5.90402 9.35067 5.85869 9.22267 5.85869 9.068V8.932C5.85869 8.77733 5.90402 8.652 5.99469 8.556C6.09069 8.45467 6.24002 8.404 6.44269 8.404C6.64536 8.404 6.79202 8.45467 6.88269 8.556C6.97869 8.652 7.02669 8.77733 7.02669 8.932V9.068C7.02669 9.22267 6.97869 9.35067 6.88269 9.452C6.79202 9.548 6.64536 9.596 6.44269 9.596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanTooltipIconActive);
export default __webpack_public_path__ + "static/media/planTooltipIconActive.e5c26a7e099512127ac080f0e5329f07.svg";
export { ForwardRef as ReactComponent };